<template>
  <div class="Charts1Border" :style="backgroundStyle">
    <!-- <div
      class="charts-controller"
      :style="{
        fontSize: $w_Ratio(0, $store) + 'px',
        width: $w_Ratio(80, $store) + 'px',
        height: $h_Ratio(25, $store) + 'px',
        top: $h_Ratio(4, $store) + 'px',
      }"
    >
      <div
        class="charts-c charts-c-sm"
        @click="handleChangeShow('smallify')"
        @mouseenter="handleEnterSM(true)"
        @mouseleave="handleEnterSM(false)"
        :style="{}"
      >
        <img
          src="@/assets/img/chartsController/smallify.png"
          :style="{
            transform: `rotate(180deg) translateY(20px)`,
            filter: `drop-shadow(${titleStyle.titleColor} 0px -20px 0px)`,
            backgroundColor: controllerBK.SM,
          }"
          alt=""
        />
      </div>
      <div
        class="charts-c charts-c-mi"
        @click="handleChangeShow('minify')"
        @mouseenter="handleEnterMI(true)"
        @mouseleave="handleEnterMI(false)"
        :style="{}"
      >
        <img
          src="@/assets/img/chartsController/minimize.png"
          :style="{
            transform: `rotate(180deg) translateY(20px)`,
            filter: `drop-shadow(${titleStyle.titleColor} 0px -20px 0px)`,
            backgroundColor: controllerBK.MI,
          }"
          alt=""
        />
      </div>
      <div
        class="charts-c charts-c-ma"
        @click="handleChangeShow('maxify')"
        @mouseenter="handleEnterMA(true)"
        @mouseleave="handleEnterMA(false)"
        :style="{}"
      >
        <img
          src="@/assets/img/chartsController/maximize.png"
          :style="{
            transform: `rotate(180deg) translateY(20px)`,
            filter: `drop-shadow(${titleStyle.titleColor} 0px -20px 0px)`,
            backgroundColor: controllerBK.MA,
          }"
          alt=""
        />
      </div>
    </div> -->
    <!-- 空谷幽兰 -->
    <div class="header" v-if="componentName == 'V1Style'">
      <span
        class="b-mtline-dec"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 800,
          color: titleStyle.titleColor,
          paddingLeft: $w_Ratio(30, $store) + 'px',
          paddingTop: $h_Ratio(8, $store) + 'px',
        }"
        >{{ Configuration.propertyData.titleText.value }}</span
      >
    </div>
    <!-- 只此青蓝 -->
    <div class="herder-2" v-if="componentName == 'V2Style'">
      <div
        class="title-green"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 800,
          color: titleStyle.titleColor,
          paddingLeft: $w_Ratio(8, $store) + 'px',
        }"
      >
        <span>{{ Configuration.propertyData.titleText.value }}</span>
      </div>
    </div>
    <!-- 蔚蓝时代 -->
    <div class="herder-3" v-if="componentName == 'V3Style'">
      <div
        class="title-blue"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 800,
          color: titleStyle.titleColor,
          //paddingLeft: $w_Ratio(8, $store) + 'px',
        }"
      >
        <div
          class="title"
          :style="{
            fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
            fontWeight: 800,
            color: titleStyle.titleColor,
            //paddingLeft: $w_Ratio(8, $store) + 'px',
          }"
        >
          <div class="bar"></div>
          <span>{{ Configuration.propertyData.titleText.value }}</span>
        </div>
      </div>
    </div>
    <!-- 紫气东来 -->
    <div class="header-4" v-if="componentName == 'V4Style'">
      <div class="title">
        <div class="square"></div>
        <!--    width: $w_Ratio(160, $store) + 'px', -->
        <div
          :style="{
            fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
            fontWeight: 600,
            color: titleStyle.titleColor,
            paddingLeft: $w_Ratio(12, $store) + 'px',
            width: $w_Ratio(100, $store) + '%',
            textAlign: 'left',
          }"
        >
          {{ Configuration.propertyData.titleText.value }}
        </div>
      </div>
    </div>
    <!-- 绿野仙踪 -->
    <div class="herder-5" v-if="componentName == 'V5Style'">
      <div
        class="title-green"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 800,
          color: titleStyle.titleColor,
          paddingLeft: $w_Ratio(8, $store) + 'px',
        }"
      >
        <span>{{ Configuration.propertyData.titleText.value }}</span>
      </div>
    </div>
    <!-- 青绿时代 -->
    <div class="herder-6" v-if="componentName == 'V6Style'">
      <div class="left graph">
        <div class="line"></div>
        <div class="triangle"></div>
      </div>
      <div
        class="title-green"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 800,
          color: titleStyle.titleColor,
          paddingLeft: $w_Ratio(8, $store) + 'px',
        }"
      >
        <span>{{ Configuration.propertyData.titleText.value }}</span>
      </div>
      <div class="right graph">
        <div class="triangle"></div>
        <div class="line"></div>
      </div>
    </div>
    <!-- 蓝色风暴 -->
    <div class="herder-7" v-if="componentName == 'V7Style'">
      <div
        class="title-green"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 800,
          color: titleStyle.titleColor,
          paddingLeft: $w_Ratio(8, $store) + 'px',
        }"
      >
        <span>{{ Configuration.propertyData.titleText.value }}</span>
      </div>
    </div>
    <!-- 青云雅韵 -->
    <div class="herder-8" v-if="componentName == 'V8Style'">
      <div
        class="title-green"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 800,
          color: titleStyle.titleColor,
          paddingLeft: $w_Ratio(8, $store) + 'px',
        }"
      >
        <span>{{ Configuration.propertyData.titleText.value }}</span>
      </div>
    </div>
    <!-- 青云沐色 -->
    <div class="herder-9" v-if="componentName == 'V9Style'">
      <div
        class="title-green"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 800,
          color: titleStyle.titleColor,
          paddingLeft: $w_Ratio(8, $store) + 'px',
        }"
      >
        <span>{{ Configuration.propertyData.titleText.value }}</span>
      </div>
    </div>
    <!-- 青图览数 -->
    <div class="herder-10" v-if="componentName == 'V10Style'">
      <div
        class="title-green"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 800,
          color: titleStyle.titleColor,
          paddingLeft: $w_Ratio(44, $store) + 'px',
        }"
      >
        <span>{{ Configuration.propertyData.titleText.value }}</span>
      </div>
    </div>
    <!-- 赤韵数筏 -->
    <div class="herder-11" v-if="componentName == 'V11Style'">
      <!-- paddingLeft: $w_Ratio(30, $store) + 'px', -->
      <!-- paddingTop: $h_Ratio(8, $store) + 'px', -->
      <span
        class="b-mtline-dec"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',
          fontWeight: 800,
          color: titleStyle.titleColor,
          paddingLeft: '0',
          position: 'relative',
          top: $h_Ratio(6, $store) + 'px',
        }"
        >{{ Configuration.propertyData.titleText.value }}</span
      >
    </div>
    <div class="herder-12" v-if="componentName == 'V12Style' || componentName == 'V13Style'">
      <div
        class="title-green"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',

          color: titleStyle.titleColor,
          paddingLeft: $w_Ratio(8, $store) + 'px',
        }"
      >
        <span>{{ Configuration.propertyData.titleText.value }}</span>
      </div>
    </div>
    <div class="herder-14" v-if="componentName == 'V14Style'">
      <img class="style14L" src="/img/styles/titleIcons/style14L.png" alt="" />
      <img class="style14R" src="/img/styles/titleIcons/style14R.png" alt="" />
      <div
        class="title-green"
        :style="{
          fontSize: $w_Ratio(titleStyle.titleSize, $store) + 'px',

          color: titleStyle.titleColor,
        }"
      >
        <span>{{ Configuration.propertyData.titleText.value }}</span>
      </div>
    </div>
    <div :class="herderBackgColor('Style')" :style="OthersSixCharts()">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Charts1Border',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      backgroundStyle: {},
      titleStyle: {
        titleSize: 18,
        titleColor: '#fff',
      },

      controllerBK: {
        SM: '',
        MI: '',
        MA: '',
      },
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        this.updateConfiguration();
        this.setChartsOptionsFontColor();
      },
    },
  },
  mounted() {
    this.herderBackgColor();
  },
  created() {
    this.updateConfiguration();
    this.setChartsOptionsFontColor();
  },
  computed: {
    componentName() {
      return this.ProjectInfo.Style.componentName;
    },
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  methods: {
    // 风格8 多行文字分组 去背景白
    OthersSixCharts() {
      // || this.Configuration.componentName == 'Others5Charts'
      if (this.ProjectInfo.Style.componentName == 'V8Style') {
        if (this.Configuration.componentName == 'Others6Charts') {
          return {
            backgroundColor: 'transparent !important',
          };
        }
      }
    },
    // 风格8 图表背景加白
    herderBackgColor(e = '') {
      let style = {};
      switch (this.style) {
        case 'V1Style':
          style['V1' + e] = true;
          break;
        case 'V2Style':
          style['V2' + e] = true;
          break;
        case 'V3Style':
          style['V3' + e] = true;
          break;
        case 'V4Style':
          style['V4' + e] = true;
          break;
        case 'V5Style':
          style['V5' + e] = true;
          break;
        case 'V6Style':
          style['V6' + e] = true;
          break;
        case 'V7Style':
          style['V7' + e] = true;
          break;
        case 'V8Style':
          style['V8' + e] = true;
          break;
        case 'V9Style':
          style['V9' + e] = true;
          break;
        case 'V10Style':
          style['V10' + e] = true;
          break;
        case 'V11Style':
          style['V11' + e] = true;
          break;
        case 'V12Style':
          style['V12' + e] = true;
          break;
        case 'V13Style':
          style['V13' + e] = true;
          break;
        case 'V14Style':
          style['V14' + e] = true;
          break;
        default:
          break;
      }
      return style;
    },
    updateConfiguration() {
      // this.backgroundStyle.backgroundColor = this.Configuration.propertyData.chartsColor.value.chartBackgroundColor;
    },
    handleChangeShow(val) {
      console.log(val);
    },
    setChartsOptionsFontColor() {
      if (this.Configuration.propertyData.fontStyle) {
        let { titleSize, titleColor } = this.Configuration.propertyData.fontStyle.value;
        this.titleStyle = {
          titleSize: parseInt(titleSize),
          titleColor,
        };
      }
    },
    handleEnterSM(isActive) {
      if (isActive) {
        this.controllerBK.SM = this.$tinycolor(this.titleStyle.titleColor).setAlpha(0.3).toRgbString();
      } else {
        this.controllerBK.SM = '';
      }
    },
    handleEnterMI(isActive) {
      if (isActive) {
        this.controllerBK.MI = this.$tinycolor(this.titleStyle.titleColor).setAlpha(0.3).toRgbString();
      } else {
        this.controllerBK.MI = '';
      }
    },
    handleEnterMA(isActive) {
      if (isActive) {
        this.controllerBK.MA = this.$tinycolor(this.titleStyle.titleColor).setAlpha(0.3).toRgbString();
      } else {
        this.controllerBK.MA = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.Charts1Border {
  width: 100%;
  height: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  .charts-controller {
    overflow: hidden;
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100px;
    height: 22px;
    display: flex;
    justify-content: space-around;
    z-index: 0;
    .charts-c {
      width: 22%;
      height: 70%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .header-0 {
    background-size: 100% 100%;
    display: flex;
    width: 100%;
    max-width: 400px;
    min-height: 30px;
    height: 10%;
    position: relative;
    .b-mtline-dec {
      background-clip: text;
      color: #fff;
      font-weight: 1000;
    }
  }
  .header {
    background: url('/img/styles/titleIcons/youlan_title.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    width: 100%;
    max-width: 400px;
    min-height: 30px;
    height: 10%;
    position: relative;
    .b-mtline-dec {
      background-clip: text;
      color: #fff;
      font-weight: 1000;
    }
  }
}
.V9Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V11Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V12Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V13Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V8Style {
  background: #ffffff;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.V7Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V6Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V5Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V4Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V3Style {
  background: transparent;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.V2Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V1Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V10Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.V14Style {
  background: transparent;
  width: 100%;
  height: 100%;
}
.herder-2 {
  background: url('/img/styles/titleIcons/cyan_title.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  max-width: 400px;
  min-height: 26px;
  height: 6%;
  padding: 1% 0;
  .title-green {
    z-index: 2;
  }
  span {
    margin-top: -10px;
    margin-left: 10px;
  }
}
.herder-3 {
  // background: url('/img/styles/titleIcons/blue_title.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  max-width: 400px;
  min-height: 14px;
  height: auto;
  margin-bottom: 10px;
  // display: flex;
  // align-items: center;
  // position: relative;
  .title-blue {
    // position: absolute;
    // z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: left;
    align-items: center;

    div.title {
      // margin-top: -10px;
      // margin-left: 10px;
      height: 100%;
      display: flex;
      align-items: center;
      &::after {
        display: none;
      }
      // display: inline-block;
      &::before {
        content: '';
        height: 90%;
        width: 4px;
        background: linear-gradient(to bottom, #02eaf2, #1663a6);
        // box-shadow: 0 0 2px 2px #3dc7cc;
        border-radius: 4px;
        margin-right: 10px;
        box-shadow: 0 0 4px 0px #10d5ff;
      }

      span {
        // background: red;
        // -webkit-background-clip: text;
        // background-clip: text;
        // display: inline-block;
      }
    }
  }
}
.header-4 {
  background: url('/img/styles/titleIcons/purple_title.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  // margin: 0 auto;
  min-height: 30px;
  margin-bottom: 2px;
  max-width: 318px;
  // height: 100%;
  height: 10%;
  position: relative;
  .line {
    width: 100%;
    height: 1px;
    background: radial-gradient(circle, #655d75, transparent);
  }
  .title {
    padding-left: 30px;
    height: 100%;
    display: flex;
    // justify-content: space-between;
    background: radial-gradient(circle, #2b1f50, transparent);
    align-items: center;
  }
  .square {
    width: 6px;
    height: 6px;
    background: linear-gradient(to bottom, #ffd100, #ff7900);
  }
}
.herder-5 {
  background: url('/img/styles/titleIcons/green_title.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  max-width: 400px;
  min-height: 40px;
  height: 10%;
  position: relative;

  .title-green {
    position: absolute;
    z-index: 2;
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      margin-top: 10px;
    }
  }
}
.herder-6 {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .graph {
    width: 33%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .left {
    .line {
      margin-right: 6px;
      width: 80%;
      min-height: 6px;
      background: linear-gradient(to right, #0e0e0f, #434953);
    }
    .triangle {
      width: 20%;
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-left: 8px solid #fffe47;
    }
  }
  .right {
    .line {
      margin-left: 6px;
      width: 80%;
      min-height: 6px;
      background: linear-gradient(to right, #434953, #0e0e0f);
    }
    .triangle {
      width: 20%;
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-right: 8px solid #fffe47;
    }
  }
}
.herder-7 {
  background: url('/img/styles/titleIcons/V7_title.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  min-height: 32px;
  height: 10%;
  position: relative;

  .title-green {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.herder-9 {
  background: url('/img/styles/titleIcons/V9_title.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  min-height: 30px;
  height: 10%;
  position: relative;
  .title-green {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      color: #fff;
    }
  }
}
.herder-10 {
  background: url('/img/styles/titleIcons/V10_title.png') no-repeat;
  /* background-size: 100% 100%; */
  width: 100%;
  min-height: 30px;
  height: 10%;
  position: relative;
  .title-green {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      color: #fff;
    }
  }
}
.herder-11 {
  background: url('/img/styles/titleIcons/V11_title.png') no-repeat;
  background-size: 100% 100%;
  width: 33%;
  min-width: 342px;
  min-height: 34px;
  height: 10%;
  position: relative;
  .title-green {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      color: #fff;
    }
  }
}
.herder-12 {
  background: url('/img/styles/titleIcons/V12_title.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  min-height: 32px;
  height: 10%;
  position: relative;

  .title-green {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    font-weight: bold;
    align-items: center;
  }
}
.herder-14 {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  width: 100%;
  min-height: 30px;
  height: 10%;
  position: relative;
  gap: 0.34vw;

  .title-green {
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;

    font-weight: bold;
    align-items: center;
  }
  .style14R {
    position: absolute;
    bottom: 4px;
    left: 22px;
    height: 14px;
    width: 100%;
  }
  .style14L {
    max-width: 20px;
  }
}
.herder-8 {
  background-size: 100% 100%;
  width: 100%;
  min-height: 32px;
  height: 6%;
  position: relative;
  .title-green {
    position: absolute;
    z-index: 2;
    background-color: transparent;
    width: 100%;
    height: 90%;
    display: flex;
    align-items: center;
    span {
      color: #61748a;
    }
  }
}
@media screen and (min-width: 2500px) {
  .herder-11 {
    width: 38% !important;
    min-width: 516px !important;
    min-height: 44px !important;
  }
  .herder-14 .title-green {
    font-size: 28px !important;
  }
}
</style>
